/**
 * DealPriceReporter — "Price look wrong? Tell us ›" contextual link (T35.6.3).
 *
 * Proto: `.ds-reportprice` on the deal detail panel in app-planning.html.
 * Quiet pull-link (muted text, no decoration) that stamps deal context
 * onto the report sheet when tapped. No severity — the context implies it.
 *
 * Usage: render inside DealOverlay next to the deal detail row, passing the
 * `flyerDealId` / `dealLabel` from the active card.
 */

import type { CSSProperties } from 'react';
import { openReportProblemSheet } from './report-events';
import { captureScreenContext } from './screenContext';

interface DealPriceReporterProps {
  offerId: string | null;
  dealLabel: string;
}

const linkStyle: CSSProperties = {
  display: 'inline-block',
  fontSize: 'var(--font-size-xs)',
  fontWeight: 'var(--font-weight-semibold)',
  color: 'var(--color-text-muted)',
  cursor: 'pointer',
  marginTop: 'var(--space-2)',
  background: 'none',
  border: 'none',
  padding: 0,
  fontFamily: 'var(--font-family-sans)',
};

export function DealPriceReporter({ offerId, dealLabel }: DealPriceReporterProps): JSX.Element {
  const handleClick = () => {
    openReportProblemSheet({
      itemContext: { kind: 'deal', offerId, label: dealLabel },
      screenContext: captureScreenContext(),
    });
  };

  return (
    <button
      type="button"
      style={linkStyle}
      onClick={handleClick}
      data-testid="deal-price-reporter"
    >
      ⚠ Price look wrong? Tell us ›
    </button>
  );
}
